import { render, staticRenderFns } from "./recentWorkInfo.vue?vue&type=template&id=3ab57cd4&scoped=true&"
import script from "./recentWorkInfo.vue?vue&type=script&lang=js&"
export * from "./recentWorkInfo.vue?vue&type=script&lang=js&"
import style0 from "./recentWorkInfo.vue?vue&type=style&index=0&id=3ab57cd4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab57cd4",
  null
  
)

export default component.exports